module.exports = __webpack_public_path__ + "static/media/Formato_Cargar_Calificaciones_Servicios.6e353f67.xlsx";